<span class="game-state-info"> {{ currentPeriod }}/{{ periodCount }} </span>
<span class="game-time-info">
  {{ gameTime | countdown : currentPeriod : periodLength : overtimeLength : sport }}
</span>
<span class="game-state-info">
  {{ strengthState }}
</span>
